import React from "react";
import { useTranslation } from "react-i18next";

interface GridTableQrcodeProps {
  children: React.ReactNode;
}

const headers = [
  "qrcode",
  "serialNumber",
  "link",
  "type",
  "status",
  "actions"
];


const GridTableQrcode: React.FC<GridTableQrcodeProps> = ({ children }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const isRtl = lang === "ar";

  return (
    <div className="w-full max-h-[450px]">
      {/* Fixed Header for Large Screens */}
      <div className="hidden lg:block w-full bg-gray-100 sticky top-0 z-50">
        <table className="w-full table-fixed border-collapse">
          <colgroup>
            <col className="w-[20%]" />
            <col className="w-[20%]" />
            <col className="w-[26%]" />
            <col className="w-[12%]" />
            <col className="w-[12%]" />
            <col className="w-[12%]" />
          </colgroup>
          <thead>
            <tr>
              {headers.map(( index) => (
                <th
                  key={index}
                  className={`px-4 py-3 text-sm font-semibold capitalize tracking-wider text-gray-700 border-b ${isRtl ? "text-right" : "text-left"
                    }`}
                >
                   {t(`qrTable.${index}`)}
                </th>
              ))}
            </tr>
          </thead>
        </table>
      </div>

      {/* Scrollable Table for Small Screens */}
      <div className="thin-scrollbar max-h-[400px] w-full overflow-y-auto rounded-lg relative">
        <table className="w-full lg:table-fixed border-collapse">
          <colgroup>
            <col className="w-[20%]" />
            <col className="w-[20%]" />
            <col className="w-[26%]" />
            <col className="w-[12%]" />
            <col className="w-[12%]" />
            <col className="w-[12%]" />
          </colgroup>

          {/* Sticky Header for Small Screens */}
          <thead className="lg:hidden bg-gray-100 sticky top-0 z-50">
            <tr>
              {headers.map(( index) => (
                <th
                  key={index}
                  className={`px-4 py-3 text-sm font-semibold capitalize tracking-wider text-gray-700 border-b ${isRtl ? "text-right" : "text-left"
                    }`}
                >
               {t(`qrTable.${index}`)}
                </th>
              ))}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  );
};

export default GridTableQrcode;
